import React, { useState } from "react";
import { Input } from "@/components/ui/input";

const inp = "h-9 bg-slate-950/60 border-slate-700 text-sm";
const matches = (c, q) => !q || [c.company, c.name, c.phone, ...(c.vehicles || []).flatMap((v) => [v.plate, v.make_model])].some((x) => (x || "").toLowerCase().includes(q));

const Fd = ({ label, children }) => <div className="block text-xs text-slate-400 space-y-1"><span>{label}</span>{children}</div>; // not a <label>: clicks inside must not re-target

export function B2bPicker({ clients, value, onPick }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const picked = clients.find((c) => c.id === value);
  const needle = q.trim().toLowerCase();
  const list = clients.filter((c) => matches(c, needle)).slice(0, 30);
  if (picked) {
    return (
      <Fd label="B2B / fleet client · 企业客户">
        <div className="flex items-center justify-between gap-2 h-9 rounded-md border border-amber-500/60 bg-amber-500/10 px-3 text-sm" data-testid="qa-b2b-picked">
          <span className="truncate font-semibold text-amber-300">{picked.company || picked.name}</span>
          <button type="button" onClick={() => { onPick(null); setQ(""); }} data-testid="qa-b2b-clear" className="text-xs text-slate-400 hover:text-slate-200 underline shrink-0">Change</button>
        </div>
      </Fd>
    );
  }
  return (
    <Fd label="B2B / fleet client · 企业客户">
      <div className="relative">
        <Input value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} data-testid="qa-b2b" className={inp} placeholder="Type company, name or plate… (leave empty for walk-in)" />
        {open && (
          <ul role="listbox" data-testid="qa-b2b-list" className="absolute z-20 mt-1 w-full max-h-52 overflow-y-auto rounded-md border border-slate-700 bg-[#0F172A] shadow-xl py-1">
            {list.length === 0 && <li className="px-3 py-2 text-xs text-slate-500">No client matches "{q}"</li>}
            {list.map((c) => {
              const plateHit = needle && (c.vehicles || []).find((v) => (v.plate || "").toLowerCase().includes(needle) || (v.make_model || "").toLowerCase().includes(needle));
              return (
                <li key={c.id}><button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(c); setOpen(false); }} data-testid={`qa-b2b-opt-${c.id}`} className="w-full text-left px-3 py-2 hover:bg-slate-800 focus:bg-slate-800 outline-none">
                  <div className="text-sm font-semibold text-slate-100 truncate">{c.company || c.name}</div>
                  <div className="text-[11px] text-slate-400 truncate">{c.company && c.name ? `${c.name} · ` : ""}{c.vehicles?.length || 0} vehicle{c.vehicles?.length === 1 ? "" : "s"}{plateHit ? <span className="text-amber-300 font-mono-num"> · {plateHit.plate}{plateHit.make_model ? ` ${plateHit.make_model}` : ""}</span> : ""}</div>
                </button></li>
              );
            })}
          </ul>
        )}
      </div>
    </Fd>
  );
}
